export default {
    data() {
        return { cashCollectors: [], loadingCashCollectors: false, cashCollectorsError: '' }
    },
    mounted() { this.loadCashCollectors() },
    methods: {
        async loadCashCollectors() {
            this.loadingCashCollectors = true
            this.cashCollectorsError = ''
            try {
                const response = await window.axios.post('api/employees/cash-collectors')
                this.cashCollectors = response.data.employees
                if (!this.cashCollectors.some(employee => String(employee.id) === String(this.form.collectedbyid))) this.form.collectedbyid = ''
            } catch (error) {
                this.cashCollectors = []
                this.cashCollectorsError = 'Unable to load cash collectors. Please retry.'
            } finally { this.loadingCashCollectors = false }
        },
        validateCashCollector() {
            if (this.loadingCashCollectors || !this.cashCollectors.some(employee => String(employee.id) === String(this.form.collectedbyid))) {
                this.$notify({ text: 'Select an authorised cash collector.', type: 'error' })
                return false
            }
            return true
        },
        handlePaymentError(error) {
            this.submitfalse = false
            this.$store.commit('assignloadingstatus', 0)
            const data = (error.response && error.response.data) || error
            const messages = data.errors && Object.values(data.errors)
            this.$notify({ text: messages && messages.length ? messages[0][0] : data.message || 'Unable to save payment.', type: 'error' })
            this.loadCashCollectors()
        },
    },
}
